import React, { CSSProperties } from "react";

interface NavMenuItem {
  label: string;
  href: string;
}

interface NavMenuExportProps {
  items?: NavMenuItem[];
  gap?: number;
  fontSize?: number;
  fontWeight?: number;
}

export const NavMenuExport: React.FC<NavMenuExportProps> = ({
  items = [],
  gap = 24,
  fontSize = 14,
  fontWeight = 500,
}) => {
  const containerStyle: CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: `${gap}px`,
    marginLeft: "auto",
  };

  const linkStyle: CSSProperties = {
    fontWeight: fontWeight,
    fontSize: `${fontSize}px`,
    color: "inherit",
    textDecoration: "none",
    transition: "opacity 0.2s",
    whiteSpace: "nowrap",
  };

  return (
    <div className="nav-menu" style={containerStyle}>
      {items.map((item, index) => (
        <a key={index} href={item.href} className="nav-menu-link" style={linkStyle}>
          {item.label}
        </a>
      ))}
    </div>
  );
};
